import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMainImage } from '../../../utils/image-utils';

interface Product {
  id: number;
  name: string;
  price: number;
  original_price?: number;
  images?: { main: string; colors?: { [color: string]: string } };
  discount_percent?: number;
}

interface Set {
  id: number;
  name: string;
  description?: string;
  products: Product[];
  active: boolean;
}

function Conjuntos() {
  const [sets, setSets] = useState<Set[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSets();
  }, []);

  const loadSets = async () => {
    setLoading(true);
    try {
      const response = await fetch(getApiEndpoint('/sets'));
      const data = await response.json();
      setSets(data);
    } catch (error) {
      console.error('Erro ao carregar conjuntos:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price: number) => {
    return `R$ ${price.toFixed(2).replace('.', ',')}`;
  };

  if (loading) {
    return (
      <div className="mobile-content">
        <div className="loading-message">Carregando conjuntos...</div>
      </div>
    );
  }

  return (
    <div className="mobile-content">
      <section className="products-section">
        <h2 className="section-title">Conjuntos</h2>
        {sets.length === 0 ? (
          <div className="empty-message">Nenhum conjunto disponível no momento</div>
        ) : (
          <div className="products-grid">
            {sets.map((set) => {
              // Calcular preço total do conjunto
              const totalPrice = set.products.reduce((sum, product) => sum + product.price, 0);
              const totalOriginalPrice = set.products.reduce(
                (sum, product) => sum + (product.original_price || product.price),
                0
              );
              const discount = totalOriginalPrice > totalPrice
                ? Math.round(((totalOriginalPrice - totalPrice) / totalOriginalPrice) * 100)
                : null;

              return (
                <div key={set.id} className="product-card">
                  {discount && <div className="product-badge">-{discount}%</div>}
                  {set.products.length > 0 && (
                    <img
                      src={getMainImage(set.products[0].images)}
                      alt={set.name}
                      className="product-image"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = `data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='200' height='200' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle' font-family='Arial, sans-serif' font-size='12' fill='%23999'%3EConjunto%3C/text%3E%3C/svg%3E`;
                      }}
                    />
                  )}
                  <div className="product-info">
                    <div className="product-name">{set.name}</div>
                    {set.description && (
                      <p className="product-description-small">{set.description}</p>
                    )}
                    <div className="product-price">
                      <span className="current-price">{formatPrice(totalPrice)}</span>
                      {totalOriginalPrice > totalPrice && (
                        <span className="old-price">{formatPrice(totalOriginalPrice)}</span>
                      )}
                    </div>
                    <p className="set-products-count">
                      {set.products.length} {set.products.length === 1 ? 'peça' : 'peças'}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}

export default Conjuntos;

